import { KeyValue } from '@angular/common';
import { Component, inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppStore, SnackbarWarningAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Formacion, GaudeFormacion } from '../../../model/classes/gaude-formacion';
import { ALUMNO_FORMACION_DATALIST_NAME } from '../../../model/contants/datalists';
import { UdeuService } from '../../../services/udeu.service';

@Component({
  templateUrl: './create-record-formacion.dialog.html',
  styleUrls: ['./create-record-formacion.dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateRecordFormacionDialogComponent implements OnInit {
  loading: boolean;

  options: Formacion[] = [];
  formacion: Formacion;
  selectedOption: KeyValue<string, string>;

  private _formBuilder = inject(FormBuilder);

  formGroup: FormGroup<any> = this._formBuilder.group({
    search: ['', [Validators.minLength(3)]]
  });

  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  constructor(protected store: Store<AppStore>, private udeuService: UdeuService) {}

  ngOnInit(): void {
    this.loading = false;
  }

  async searchFormacion(): Promise<void> {
    const valueStudent = this.formGroup.get('search').value;
    if (typeof valueStudent === 'string' && valueStudent.length >= 3) {
      this.loading = true;
      this.autocompleteTrigger.closePanel();
      this.formacion = null;
      try {
        const results: GaudeFormacion = await this.udeuService.getGaudeDataListValues(ALUMNO_FORMACION_DATALIST_NAME, valueStudent);
        this.options = results?.items?.map((formation) => {
          return {...formation, campus: formation.campus?.trim()}
        });
        if (this.options?.length === 1) {
          this.formacion = this.options[0];
          this.formGroup.get('search').setValue(this.formacion);
        } else {
          this.autocompleteTrigger.openPanel();
        }
      } catch (err) {
        console.error(err);
        this.store.dispatch(new SnackbarWarningAction('No se pudo obtener alumnos.'));
      } finally {
        this.loading = false;
      }
    } else if (valueStudent.length < 3) {
      throw new Error('Method not implemented.');
    }
  }

  displayFn(formacion: Formacion): string {
    return formacion ? `${formacion.idcurso ? formacion.idcurso + ' ' : ''}${formacion.campus ? formacion.campus + ': ' : ''}${formacion.año_imparticion} / ${formacion.num_edicion} / ${formacion.nombre_curso}` : '';
  }

  selectFormacion(formacion: Formacion): void {
    this.formacion = formacion;
    this.formGroup.get('search').setValue(formacion);
  }

}